module.exports = new __parcel__URL__("Software Arch Review Hover.0efbbff0.svg").toString();